import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Modal, ModalBody, Container, Row, Col, FormGroup, Input, Form } from 'reactstrap';
import useApi from 'vl-common/src/hooks/useApi';
import { AlertMessage } from 'vl-common/src/components/AlertMessage/AlertMessage';
import { LoadingButton } from 'vl-common/src/components/LoadingButton';
import { tools } from 'vl-common/src/lib/service.tools';

const AddUbrn = (props) => {
  const { t } = useTranslation('common');
  const { Api, consumed } = useApi();
  const { close, data } = props;
  const [modal, setModal] = useState(false);
  const [loading_create, setLoading_create] = useState(false);
  const [showAlertMessage, setShowAlertMessage] = useState({
    visibility: false,
    msg: ''
  });
  const [ubrn, setUBRN] = useState('');

  const toggle = () => {
    setModal(false);
    close();
    setUBRN('');
    setLoading_create(false);
  };

  useEffect(() => {
    if (props.show) {
      //load data
    }
    setModal(props.show || false);
  }, [props.show]);

  const displayAlertMessage = (msg = '') => {
    setShowAlertMessage({ visibility: true, msg });
    const t = setTimeout(() => {
      setShowAlertMessage({ visibility: false, msg });
      clearTimeout(t);
    }, 7000);
  };

  const createNote = (data) => {
    Api.notes
      .createNotes({
        ...data
      })
      .then((res) => {
        setLoading_create(false);
        if (props.onCreated) {
          props.onCreated('Add');
        }
      })
      .catch((e) => {
        if (e.response?.status) {
          const status = e.response.status;
          displayAlertMessage(`Error-${status}`);
        }
        setLoading_create(false);
      });
  };

  const createHandler = async () => {
    if (!isFormValid()) return;
    setLoading_create(true);
    try {
      const default_data = {
        case_id: data.case_id,
        note_text: '',
        category: 'ERS',
        ubrn: ubrn
      };
      if ((await isUBRNValid(ubrn, data?.case_id)) !== true) {
        displayAlertMessage('UBRN invalid - please check UBRN or membership number/nhs number');
      } else {
        createNote(default_data);
      }
    } finally {
      setLoading_create(false);
    }
  };

  // check if ubrn contains any data
  // is a promise to avoid timing concerns with validity check
  const isUBRNValid = async (ubrn, case_id) => {
    try {
      const res = await Api.referrer.checkUbrn(ubrn, case_id);
      return res.data.ubrn === ubrn;
    } catch (e) {
      if (e.response.status === 400) {
        consumed(e);
        return false;
      }
      throw e;
    }
  };

  const isFormValid = () => {
    if (tools.isEmptyOrNull(ubrn)) {
      displayAlertMessage('Please enter the UBRN');
      return false;
    }
    return true;
  };

  return (
    <div>
      <Modal
        centered
        className="vl-add-modal"
        size={'xl'}
        isOpen={modal}
        toggle={toggle}
        backdrop={'static'}
        keyboard={false}
      >
        <ModalBody className="p-5 vl-addNote">
          <Container fluid={true}>
            <Row>
              <AlertMessage message={showAlertMessage.msg} visibility={showAlertMessage.visibility} />
              <Col xs="12" className="text-center">
                <span className="vl-modal-title">
                  <span className="vl-primary-dark-text">{t('Add_2')}</span>
                  <span className="vl-gray ">{t('UBRN')}</span>
                </span>
              </Col>
              <br />
              <Col xs="12">
                <Form className="mt-3">
                  <input type="hidden" value="something" />
                  <Row>
                    <Col xs="12">
                      <FormGroup>
                        <Input
                          type="text"
                          placeholder={t('Enter UBRN here')}
                          value={ubrn}
                          onChange={(e) => setUBRN(e.target.value)}
                        />
                      </FormGroup>
                    </Col>
                    <Col xs="12" className="text-center">
                      <Button
                        className="vl-button-gray vl-font-regular"
                        type="button"
                        onClick={toggle}
                        data-testid="cancel-add-ubrn-modal-button"
                      >
                        {t('Cancel')}
                      </Button>
                      <LoadingButton
                        className="vl-button vl-font-regular min-width"
                        onClick={createHandler}
                        loading={loading_create}
                        disabled={loading_create}
                        data-testid="confirm-add-ubrn-button"
                      >
                        {loading_create ? t('Saving...') : t('Save')}
                      </LoadingButton>
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>
          </Container>
        </ModalBody>
      </Modal>
    </div>
  );
};

export { AddUbrn };
